// extracted by mini-css-extract-plugin
export default {"search":"MySearch_search__YoJeD","search__input":"MySearch_search__input__cSIys","search__button":"MySearch_search__button__0cORf"};